import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-131">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-132">
        <motion.div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
        backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/wCY32QXM3JDSp2ZsR1AJCT/Image4.jpg")'
      }} animate={{
        scale: [1, 1.1, 1]
      }} transition={{
        duration: 20,
        ease: 'linear',
        repeat: Infinity
      }} data-id="element-133" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60" data-id="element-134" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto mt-16" data-id="element-135">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2
      }} data-id="element-136">
          <span className="inline-block font-medium tracking-widest uppercase text-sm mb-4 text-[#E5DCC9]" data-id="element-137">
            52 bytových jednotek · Dolní Jirčany · Praha-západ
          </span>
          <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl text-white font-bold mb-6 drop-shadow-lg" data-id="element-138">
            Dům u Sv. Václava
          </h1>
          <p className="text-xl md:text-2xl text-white/90 font-light mb-10 text-balance max-w-2xl mx-auto" data-id="element-139">
            Nejmodernější ekologický bytový dům v České republice
          </p>

          <a href="#o-projektu" className="inline-block bg-accent hover:bg-accent-hover text-white px-8 py-4 rounded-sm transition-colors duration-300 font-medium tracking-wide" data-id="element-140">
            Zjistit více
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div className="absolute bottom-10 left-1/2 -translate-x-1/2" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} data-id="element-141">
        <motion.a href="#o-projektu" animate={{
        y: [0, 10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} className="text-white/70 hover:text-white transition-colors flex flex-col items-center" data-id="element-142">
          <span className="text-xs uppercase tracking-widest mb-2" data-id="element-143">
            Rolujte dolů
          </span>
          <ChevronDownIcon className="w-6 h-6" data-id="element-144" />
        </motion.a>
      </motion.div>
    </section>;
}